var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c(
        "md-layout",
        { attrs: { "md-flex": "90", "md-flex-offset": "5" } },
        [
          _c(
            "md-card",
            { staticClass: "md-table-card content-table" },
            [
              _c("md-card-header", [
                _c("div", { staticClass: "header-row" }, [
                  _c("h2", { staticClass: "md-title" }, [
                    _vm._v("Client Financial Summary")
                  ]),
                  _c("div", { staticClass: "header-right" }, [
                    _c(
                      "div",
                      { staticClass: "period-control" },
                      [
                        _c("span", { staticClass: "period-label-text" }, [
                          _vm._v("Period:")
                        ]),
                        _c(
                          "md-button",
                          {
                            staticClass: "md-icon-button",
                            attrs: { disabled: _vm.loading },
                            on: { click: _vm.prevPeriod }
                          },
                          [
                            _c("md-icon", {
                              attrs: { "md-iconset": "fa fa-chevron-left" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "md-menu",
                          {
                            attrs: {
                              "md-direction": "bottom-end",
                              "md-size": "auto"
                            }
                          },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-icon-button",
                                attrs: { "md-menu-trigger": "md-menu-trigger" }
                              },
                              [
                                _c("md-icon", {
                                  attrs: { "md-iconset": "fa fa-calendar-alt" }
                                })
                              ],
                              1
                            ),
                            _c("md-menu-content", [
                              _c(
                                "div",
                                { staticClass: "period-picker-popup" },
                                [
                                  _c(
                                    "md-input-container",
                                    [
                                      _c("label", [_vm._v("Month")]),
                                      _c(
                                        "md-select",
                                        {
                                          on: { selected: _vm.onPeriodChanged },
                                          model: {
                                            value: _vm.filters.month,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "month",
                                                $$v
                                              )
                                            },
                                            expression: "filters.month"
                                          }
                                        },
                                        _vm._l(_vm.months, function(m) {
                                          return _c(
                                            "md-option",
                                            {
                                              key: m.value,
                                              attrs: { value: m.value }
                                            },
                                            [_vm._v(_vm._s(m.name))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "md-input-container",
                                    [
                                      _c("label", [_vm._v("Year")]),
                                      _c(
                                        "md-select",
                                        {
                                          on: { selected: _vm.onPeriodChanged },
                                          model: {
                                            value: _vm.filters.year,
                                            callback: function($$v) {
                                              _vm.$set(_vm.filters, "year", $$v)
                                            },
                                            expression: "filters.year"
                                          }
                                        },
                                        _vm._l(_vm.years, function(y) {
                                          return _c(
                                            "md-option",
                                            {
                                              key: y.value,
                                              attrs: { value: y.value }
                                            },
                                            [_vm._v(_vm._s(y.value))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        ),
                        _c("span", { staticClass: "current-period-label" }, [
                          _vm._v(_vm._s(_vm.currentPeriodLabel))
                        ]),
                        _c(
                          "md-button",
                          {
                            staticClass: "md-icon-button",
                            attrs: { disabled: _vm.loading },
                            on: { click: _vm.nextPeriod }
                          },
                          [
                            _c("md-icon", {
                              attrs: { "md-iconset": "fa fa-chevron-right" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _c(
                "stitch-loader",
                { attrs: { loading: _vm.loading, size: 45 } },
                [
                  !_vm.loading && _vm.clients.length === 0
                    ? _c(
                        "div",
                        { staticClass: "no-data" },
                        [
                          _c("md-icon", {
                            staticClass: "md-accent",
                            attrs: { "md-iconset": "fa fa-exclamation-circle" }
                          }),
                          _c("span", [
                            _vm._v(
                              "No financial data found for the selected period."
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.clients.length > 0
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "table" },
                          [
                            _c("div", { staticClass: "titleLine styleRow" }, [
                              _c("p", {
                                staticClass: "rowElements col-expand"
                              }),
                              _c(
                                "p",
                                { staticClass: "rowElements col-client" },
                                [_vm._v("Client")]
                              ),
                              _c(
                                "p",
                                { staticClass: "rowElements col-money" },
                                [_vm._v("Platform Fee")]
                              ),
                              _c(
                                "p",
                                { staticClass: "rowElements col-money" },
                                [_vm._v("Videos Purchased")]
                              ),
                              _c(
                                "p",
                                { staticClass: "rowElements col-money" },
                                [_vm._v("Videos Sold Net Revenue")]
                              ),
                              _c(
                                "p",
                                { staticClass: "rowElements col-money" },
                                [_vm._v("Rentals Net Revenue")]
                              ),
                              _c(
                                "p",
                                { staticClass: "rowElements col-money" },
                                [_vm._v("Total")]
                              ),
                              _c(
                                "p",
                                { staticClass: "rowElements col-actions" },
                                [_vm._v("Actions")]
                              )
                            ]),
                            _vm._l(_vm.clients, function(client) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: client.accountId,
                                    staticClass: "styleRow colorHover",
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleExpand(
                                          client.accountId
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "rowElements col-expand" },
                                      [
                                        _c("md-icon", {
                                          staticClass: "expand-icon",
                                          attrs: {
                                            "md-iconset": _vm.isExpanded(
                                              client.accountId
                                            )
                                              ? "fa fa-chevron-down"
                                              : "fa fa-chevron-right"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements col-client" },
                                      [_vm._v(_vm._s(client.accountName))]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements col-money" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              client.platformFee
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements col-money" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              client.videosPurchased.total
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "rowElements col-money" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              client.videosSold.total
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "rowElements col-money text-green"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              client.rentals.net
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "rowElements col-money text-bold"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              client.grandTotal
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "rowElements col-actions"
                                      },
                                      [
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-icon-button md-raised md-primary",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.openFeeConfig(client)
                                              }
                                            }
                                          },
                                          [
                                            _c("md-icon", {
                                              attrs: {
                                                "md-iconset": "fa fa-cog"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm.isExpanded(client.accountId)
                                  ? _c(
                                      "div",
                                      {
                                        key: client.accountId + "-detail",
                                        staticClass: "detail-row"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "detail-content" },
                                          [
                                            _c("h4", [_vm._v("Videos Sold")]),
                                            client.videosSold.details &&
                                            client.videosSold.details.length > 0
                                              ? _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "sub-table"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sub-titleLine sub-styleRow"
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements"
                                                            },
                                                            [_vm._v("Buyer")]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Videos Sold"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Rhebus Fee"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money highlight-yellow"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Videos Sold (net)"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._l(
                                                        client.videosSold
                                                          .details,
                                                        function(d, idx) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "sold-" + idx,
                                                              staticClass:
                                                                "sub-styleRow"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "sub-rowElements"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      d.buyer
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "sub-rowElements col-money"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatCurrency(
                                                                        d.videosSold
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "sub-rowElements col-money"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatCurrency(
                                                                        d.rhebusFee
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "sub-rowElements col-money highlight-yellow"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatCurrency(
                                                                        d.videosSoldNet
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sub-styleRow sub-totals-row"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements",
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "600"
                                                              }
                                                            },
                                                            [_vm._v("Total")]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .videosSold
                                                                      .gross
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .videosSold
                                                                      .rhebusFee
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money highlight-yellow"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .videosSold
                                                                      .total
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ])
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "no-sub-data"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "No videos sold this period."
                                                    )
                                                  ]
                                                ),
                                            _c("h4", [
                                              _vm._v("Videos Purchased")
                                            ]),
                                            client.videosPurchased.details &&
                                            client.videosPurchased.details
                                              .length > 0
                                              ? _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "sub-table"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sub-titleLine sub-styleRow"
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements"
                                                            },
                                                            [_vm._v("Seller")]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Videos Bought"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Rhebus Fee"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money highlight-blue"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Rhebus Purchases Out"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._l(
                                                        client.videosPurchased
                                                          .details,
                                                        function(d, idx) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key:
                                                                "bought-" + idx,
                                                              staticClass:
                                                                "sub-styleRow"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "sub-rowElements"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      d.seller
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "sub-rowElements col-money"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatCurrency(
                                                                        d.videosBought
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "sub-rowElements col-money"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatCurrency(
                                                                        d.rhebusFee
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "sub-rowElements col-money highlight-blue"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatCurrency(
                                                                        d.purchasesOut
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sub-styleRow sub-totals-row"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements",
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "600"
                                                              }
                                                            },
                                                            [_vm._v("Total")]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .videosPurchased
                                                                      .total
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .videosPurchased
                                                                      .totalRhebusFee
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money highlight-blue"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .videosPurchased
                                                                      .totalRhebusPurchasesOut
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ])
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "no-sub-data"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "No videos purchased this period."
                                                    )
                                                  ]
                                                ),
                                            _c("h4", [
                                              _vm._v(
                                                "Video Rentals Out (gross)"
                                              )
                                            ]),
                                            client.rentals.gross > 0
                                              ? _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "sub-table"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sub-titleLine sub-styleRow"
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Video Rentals Out (gross)"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Roku Fees"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Stripe Fees"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Rhebus Fee"
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money highlight-green"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Video Rentals Out (net)"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sub-styleRow"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money",
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "600"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .rentals
                                                                      .gross
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money",
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "600"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .rentals
                                                                      .rokuFees
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money",
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "600"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .rentals
                                                                      .stripeFees
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money",
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "600"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .rentals
                                                                      .rhebusCommission
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "sub-rowElements col-money highlight-green",
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "600"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatCurrency(
                                                                    client
                                                                      .rentals
                                                                      .net
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "no-sub-data"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "No rentals this period."
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }),
                            _c("div", { staticClass: "styleRow totals-row" }, [
                              _c("div", {
                                staticClass: "rowElements col-expand"
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "rowElements col-client",
                                  staticStyle: { "font-weight": "600" }
                                },
                                [_vm._v("TOTALS")]
                              ),
                              _c(
                                "div",
                                { staticClass: "rowElements col-money" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatCurrency(_vm.totals.platformFee)
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "rowElements col-money" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatCurrency(
                                        _vm.totals.videosPurchased
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "rowElements col-money" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatCurrency(
                                        _vm.totals.videosSoldNet
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "rowElements col-money text-green"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatCurrency(_vm.totals.rentalsNet)
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "rowElements col-money text-bold"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatCurrency(_vm.totals.grandTotal)
                                    )
                                  )
                                ]
                              ),
                              _c("div", {
                                staticClass: "rowElements col-actions"
                              })
                            ]),
                            _c("md-table-pagination", {
                              attrs: {
                                "md-size": _vm.pagination.size,
                                "md-total": _vm.pagination.total,
                                "md-page": _vm.pagination.page,
                                "md-label": "Rows",
                                "md-separator": "of",
                                "md-page-options": [10, 25, 50]
                              },
                              on: { pagination: _vm.onPageChanged }
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _c(
            "md-dialog",
            { ref: "feeConfigDialog" },
            [
              _c("md-dialog-title", [
                _vm._v(
                  "Fee Configuration — " +
                    _vm._s(
                      _vm.selectedClient ? _vm.selectedClient.accountName : ""
                    )
                )
              ]),
              _c(
                "md-dialog-content",
                [
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("Platform Fee ($)")]),
                      _c("md-input", {
                        attrs: { type: "number", min: "0" },
                        model: {
                          value: _vm.feeForm.platformFee,
                          callback: function($$v) {
                            _vm.$set(_vm.feeForm, "platformFee", _vm._n($$v))
                          },
                          expression: "feeForm.platformFee"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("Rental Fee Rate (%)")]),
                      _c("md-input", {
                        attrs: { type: "number", min: "0", max: "100" },
                        model: {
                          value: _vm.feeForm.rentalFeeRate,
                          callback: function($$v) {
                            _vm.$set(_vm.feeForm, "rentalFeeRate", _vm._n($$v))
                          },
                          expression: "feeForm.rentalFeeRate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("License Fee Rate (%)")]),
                      _c("md-input", {
                        attrs: { type: "number", min: "0", max: "100" },
                        model: {
                          value: _vm.feeForm.licenseFeeRate,
                          callback: function($$v) {
                            _vm.$set(_vm.feeForm, "licenseFeeRate", _vm._n($$v))
                          },
                          expression: "feeForm.licenseFeeRate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "md-dialog-actions",
                [
                  _c("md-button", { on: { click: _vm.closeFeeConfig } }, [
                    _vm._v("Cancel")
                  ]),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-raised save-btn",
                      attrs: { disabled: _vm.savingFeeConfig },
                      on: { click: _vm.saveFeeConfig }
                    },
                    [_vm._v(_vm._s(_vm.savingFeeConfig ? "Saving..." : "Save"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6b6e080", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6b6e080","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/report/FinancialSummaryTable.vue
// module id = 1031
// module chunks = 0